import Header from '../Header/Header';
import { Outlet } from 'react-router-dom';
import { Container } from '@mui/material';

const Layout = () => {
  return (
    <>
      <Header />
      <main className="main-content">
        <Container maxWidth="xl" className="main-wrapper">
          <Outlet />
        </Container>
      </main>
    </>
  );
};
export default Layout;
